export interface Product {
  id: string;
  name: string;
  price: number;
  image: string;
  category: string;
  description: string;
  rating: number;
  reviews: number;
  stock: number;
}

export interface Category {
  id: string;
  name: string;
}

export const categories: Category[] = [
  { id: "all", name: "All Products" },
  { id: "electronics", name: "Electronics" },
  { id: "clothing", name: "Clothing" },
  { id: "home", name: "Home & Garden" },
  { id: "beauty", name: "Beauty" },
];

export const products: Product[] = [
  {
    id: "1",
    name: "Wireless Headphones Pro",
    price: 129.99,
    image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=500&h=500&fit=crop",
    category: "electronics",
    description: "Premium wireless headphones with noise cancellation and 30-hour battery life.",
    rating: 4.8,
    reviews: 324,
    stock: 45,
  },
  {
    id: "2",
    name: "Organic Cotton T-Shirt",
    price: 39.99,
    image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=500&h=500&fit=crop",
    category: "clothing",
    description: "Comfortable 100% organic cotton t-shirt in multiple colors.",
    rating: 4.6,
    reviews: 156,
    stock: 120,
  },
  {
    id: "3",
    name: "Smart Watch Ultra",
    price: 299.99,
    image: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500&h=500&fit=crop",
    category: "electronics",
    description: "Advanced smartwatch with fitness tracking and ECG monitor.",
    rating: 4.7,
    reviews: 289,
    stock: 32,
  },
  {
    id: "4",
    name: "Minimalist Desk Lamp",
    price: 79.99,
    image: "https://images.unsplash.com/photo-1565636192335-14275e1690f3?w=500&h=500&fit=crop",
    category: "home",
    description: "Modern LED desk lamp with adjustable brightness.",
    rating: 4.5,
    reviews: 87,
    stock: 58,
  },
  {
    id: "5",
    name: "Yoga Mat Premium",
    price: 49.99,
    image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=500&h=500&fit=crop",
    category: "home",
    description: "Non-slip yoga mat with carrying strap, 6mm thick.",
    rating: 4.9,
    reviews: 412,
    stock: 95,
  },
  {
    id: "6",
    name: "Natural Face Serum",
    price: 59.99,
    image: "https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=500&h=500&fit=crop",
    category: "beauty",
    description: "Anti-aging serum with vitamin C and hyaluronic acid.",
    rating: 4.7,
    reviews: 203,
    stock: 67,
  },
  {
    id: "7",
    name: "Denim Jacket Classic",
    price: 89.99,
    image: "https://images.unsplash.com/photo-1551028719-00167b16ebc5?w=500&h=500&fit=crop",
    category: "clothing",
    description: "Timeless denim jacket, perfect for any season.",
    rating: 4.6,
    reviews: 134,
    stock: 43,
  },
  {
    id: "8",
    name: "Ceramic Plant Pot",
    price: 34.99,
    image: "https://images.unsplash.com/photo-1578500494198-246f612d03b3?w=500&h=500&fit=crop",
    category: "home",
    description: "Beautiful handcrafted ceramic pot with drainage hole.",
    rating: 4.4,
    reviews: 98,
    stock: 72,
  },
];

export const getProductsByCategory = (categoryId: string): Product[] => {
  if (categoryId === "all") return products;
  return products.filter((p) => p.category === categoryId);
};

export const getProductById = (id: string): Product | undefined => {
  return products.find((p) => p.id === id);
};
